<template>
    <v-dialog
      v-model="showme"
      persistent
      max-width="80%"
    >
    <v-card>
        <v-card-title>
          <span class="text-h5">Medienbibliothek</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="showme = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div class="d-flex align-center">
              <v-tabs v-model="tab">
                  <v-tab :tab-value="value.value" v-for="value in tabs" :key="value.value">{{ value.title }}</v-tab>
              </v-tabs>
              <v-spacer></v-spacer>
              <span class="spaceinfo">{{spaceUsed}} MB / {{maxSpace}} MB ({{((spaceUsed/maxSpace)*100).toFixed(2)}}%) genutzt</span>
              <v-btn class="ml-2" color="primary" @click="uploadMode = !uploadMode">
                {{ uploadMode ? 'Zurück' : 'Hochladen' }}
              </v-btn>
            </div>

            <!-- Upload View -->
            <div v-if="uploadMode" class="mt-4">
              <v-card
                outlined
                class="upload-area pa-8"
                :class="{ 'drag-over': isDragging }"
                @dragover.prevent="onDragOver"
                @dragleave.prevent="onDragLeave"
                @drop.prevent="onDrop"
              >
                <div class="text-center">
                  <v-icon size="64" color="grey">mdi-cloud-upload</v-icon>
                  <h3 class="mt-4">Dateien hochladen</h3>
                  <p class="text-body-2 grey--text">Klicken oder ziehen Sie Dateien hierher</p>

                  <v-file-input
                    v-model="selectedFiles"
                    multiple
                    chips
                    show-size
                    counter
                    label="Dateien auswählen"
                    prepend-icon="mdi-paperclip"
                    class="mt-4"
                    @change="onFileSelect"
                  ></v-file-input>

                  <v-btn
                    v-if="selectedFiles && selectedFiles.length > 0"
                    color="primary"
                    class="mt-4"
                    @click="uploadFiles"
                    :loading="uploading"
                  >
                    {{ uploading ? 'Hochladen...' : 'Hochladen starten' }}
                  </v-btn>
                </div>
              </v-card>
            </div>

            <!-- Grid View -->
            <div v-else>
              <v-row class="mt-4">
                <v-col
                  v-for="item in paginatedItems"
                  :key="item"
                  cols="2"
                  class="media-item"
                >
                  <v-card>
                    <v-img
                      :src="`https://via.placeholder.com/150?text=Item+${item}`"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                    </v-img>
                    <v-card-title class="text-caption">Item {{ item }}</v-card-title>
                  </v-card>
                </v-col>
              </v-row>

              <div class="text-center mt-4">
                <v-pagination
                  v-model="page"
                  :length="totalPages"
                  :total-visible="7"
                ></v-pagination>
              </div>
            </div>
        </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
import BackendService from '@/services/BackendService';

export default {
  name: 'MediaLibrary',
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showme: false,
      tab: null,
      spaceUsed: 0,
      maxSpace: 0,
      page: 1,
      itemsPerPage: 12,
      uploadMode: false,
      selectedFiles: null,
      uploading: false,
      isDragging: false,
      tabs: [
        { title: 'Alle', value: 'all' },
        { title: 'Bilder', value: 'image' },
        { title: 'Videos', value: 'video' },
        { title: 'Audios', value: 'audio' },
      ],
      images: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
      ],
      videos: [],
      audios: [],
    };
  },
  computed: {
    allItems() {
      // Return all items or filter based on tab
      if (this.tab === 'image') return this.images;
      if (this.tab === 'video') return this.videos;
      if (this.tab === 'audio') return this.audios;
      return [...this.images, ...this.videos, ...this.audios];
    },
    totalPages() {
      return Math.ceil(this.allItems.length / this.itemsPerPage);
    },
    paginatedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.allItems.slice(start, end);
    },
  },
  methods: {
    open(argument) {
      this.tab = null;
      this.filter = null;
      this.showme = true;
      this.uploadMode = false;
      if (this.tabs.find((t) => t.value === argument) !== undefined) {
        this.tab = argument;
        this.filter = argument;
      }
    },
    onFileSelect() {
      console.log('Files selected:', this.selectedFiles);
    },
    onDragOver() {
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    onDrop(event) {
      this.isDragging = false;
      const files = Array.from(event.dataTransfer.files);
      if (files.length > 0) {
        this.selectedFiles = files;
        console.log('Files dropped:', files);
      }
    },
    async uploadFiles() {
      this.uploading = true;

      try {
        await BackendService.uploadToMediaLibrary({ files: this.selectedFiles });

        // Reset after upload
        this.selectedFiles = null;
        this.uploadMode = false;
        this.uploading = false;

        // TODO: Refresh the media list after upload
      } catch (error) {
        console.error('Upload error:', error);
        this.uploading = false;
      }
    },
  },
  mounted() {
    this.open('image');
  },
  created() {
  },
  destroyed() {
  },
};
</script>

<style scoped>
.spaceinfo {
    width: 400px;
    text-align: right;
}

.media-item {
  cursor: pointer;
}

.media-item:hover {
  opacity: 0.8;
}

.upload-area {
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  transition: all 0.3s;
}

.upload-area:hover {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.05);
}

.upload-area.drag-over {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.1);
  transform: scale(1.02);
}
</style>
